import { Navigate } from "@tanstack/react-router";
import { Overview } from "./Overview";
import { homeFor } from "../lib/nav";
import { useViewer } from "../lib/viewer";

/**
 * Where each role lands on open.
 *
 * A dental assistant goes straight to `/request`, with the item palette
 * already mounted and populated. That is not a convenience — it is the
 * precondition for the two-tap constraint. If opening the app costs a tap to
 * reach the request screen, then the best case is three, and no amount of
 * polish on the screen itself recovers it.
 *
 * Everyone else gets the overview, which is the screen their job starts from.
 */
export function Home() {
  // The shell has already resolved the viewer and refused to render this
  // screen without one — an account with no staff row never reaches here, it
  // gets the shell's "no account set up" screen instead. See lib/viewer.ts.
  const { role } = useViewer();

  // A role with no home of its own falls through to the overview.
  const destination = homeFor(role);
  if (destination !== "/") return <Navigate to={destination} replace />;

  return <Overview />;
}
